import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../context/ThemeContext';

function PrivateEvents() {
  const { theme } = useTheme();
  const tokens = theme.tokens;
  const tc = tokens.colors;

  const cardStyle = {
    background: `color-mix(in srgb, ${tc.surface} 75%, transparent)`,
    backdropFilter: 'blur(2px)',
    WebkitBackdropFilter: 'blur(6px)',
    border: `1px solid ${tc.gridLine}`,
    borderRadius: 14,
    padding: '32px 36px',
    marginTop: 24,
  };

  const h1Style = {
    fontFamily: tokens.fonts.display,
    fontSize: 'clamp(24px, 5vw, 32px)',
    fontWeight: 600,
    color: tc.ink,
    marginBottom: 20,
    lineHeight: 1.2,
  };

  const h2Style = {
    fontFamily: tokens.fonts.display,
    fontSize: 20,
    fontWeight: 600,
    color: tc.ink,
    marginTop: 28,
    marginBottom: 10,
  };

  const linkStyle = { color: tc.accent };

  return (
    <div className="container mx-auto px-4 sm:px-8 pb-12" style={{ color: tc.muted, fontFamily: tokens.fonts.ui, textAlign: 'left' }}>
      <Helmet>
        <title>List a Private Event | ATLTech.events</title>
        <meta name="description" content="Pricing and options for listing a private, invite-only tech event on the ATLTech.events Atlanta calendar." />
      </Helmet>
      <div style={cardStyle}>
        <h1 style={h1Style}>
          Private Events on ATLTech<span style={{ color: tc.accent, fontFamily: tokens.fonts.ui }}>.events</span><sup>SM</sup>
        </h1>

        <div className="space-y-4">
          <p>
            ATLTech.events lists placeholder events for private events we are aware of so that your plans can include these events. We do not provide details by default as the organizer may prefer to keep it private. If you are the host of a private event, and would like to have the details listed, we have several options.
          </p>

          <h2 style={h2Style}>Private Event Listings</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>$30 to list a single event (event and organization name, description, time, and link to register.)</li>
            <li>$50 for a sponsored event listing (your logo will be displayed on the event.)</li>
            <li>$100 for a featured event listing (your logo will be displayed on the event and the event will be featured on the calendar on the daily level and communications related to week of the event.)</li>
            <li>$250 for a featured event of the month listing (your logo will be displayed on the event, the event will be featured on the calendar at the monthly level, and all communications during the month of the event.)</li>
            <li>
              Site sponsorships are also available. Please contact us at{' '}
              <a target="_blank" rel="noopener noreferrer" style={linkStyle} className="hover:underline" href="https://www.linkedin.com/company/atl-tech-events">
                ATLTech.events on LinkedIn
              </a>{' '}
              to discuss.
            </li>
          </ul>

          <p>You must be an authorized representative of the organization hosting the private event to request a listing.</p>
        </div>
      </div>
    </div>
  );
}

export default PrivateEvents;
